import React, { useState, useEffect } from 'react';
import { achievementService } from '../api/services';
import { useSettings } from '../context/SettingsContext';
import './AchievementsSection.css';

// 各徽章家族對應的數值單位，用於進度文案顯示（例如「再 3 篇解鎖」）
const UNIT_BY_KEY = {
  post: '篇',
  comment: '則',
  accepted: '次',
  votes: '讚',
  given: '讚',
  tenure: '天',
};

// 業務邏輯：顯示登入者的成就徽章。已達成的家族以彩色呈現，未達成者轉灰並顯示距離下一階的進度。
const AchievementsSection = () => {
  const { settings } = useSettings();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 徽章收集功能總開關：後台關閉時不發查詢、整區隱藏（設定未載入或未種子化時預設為開啟）
  const badgesDisabled = settings.badge_collection_enabled === 'false';

  useEffect(() => {
    if (badgesDisabled) { setLoading(false); return; }
    achievementService.getMe()
      .then((res) => setData(res.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [badgesDisabled]);

  if (badgesDisabled) return null;
  if (loading) return <div className="achievements-section"><h3 className="ach-title">成就徽章</h3><p className="ach-loading">載入中...</p></div>;
  if (error) return null; // 成就為加分資訊，載入失敗時靜默隱藏，不干擾個人頁主要內容
  // 後端回傳 enabled=false（與設定同步的雙重保險）時亦整區隱藏
  if (data && data.enabled === false) return null;

  const { badges = [], earnedBadges = 0, totalBadges = 0 } = data || {};

  return (
    <div className="achievements-section">
      <div className="ach-header">
        <h3 className="ach-title">成就徽章</h3>
        <span className="ach-count">已獲得 <strong>{earnedBadges}</strong> / {totalBadges} 枚</span>
      </div>

      <div className="ach-grid">
        {badges.map((b) => {
          const unit = UNIT_BY_KEY[b.key] || '';
          const remaining = b.next ? Math.max(0, b.next.threshold - b.value) : 0;
          return (
            <div key={b.key} className={`ach-card ${b.earned ? 'earned' : 'locked'}`}>
              <div className="ach-icon">{b.icon}</div>
              <div className="ach-body">
                <div className="ach-name">{b.name}</div>
                <div className="ach-desc">{b.desc}</div>
                <div className="ach-progress">
                  <div className="ach-progress-bar" style={{ width: `${Math.round((b.progress || 0) * 100)}%` }} />
                </div>
                <div className="ach-hint">
                  {b.next
                    ? <>目前 {b.value} {unit}　·　再 {remaining} {unit}解鎖 {b.next.icon} {b.next.name}</>
                    : <>目前 {b.value} {unit}　·　已達最高階 🎉</>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementsSection;
